import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from 'src/modules/directives/module';
import { ListingModule } from 'src/modules/listing/module';
import { ProductModule } from '../../product/module';
import { OrganisationModule } from 'src/modules/organisation/module';
import { ListingDashboard } from './components/dashboard/component';

import { NewPagesDashlet } from './components/dashlet/new-pages/component';
import { ListingCarouselImageApiService } from './services/carousel-image-api-service';
import { ListingOrganisationService } from './services/organisation-service';
import { TicketModule } from 'src/modules/ticket/module';
import { BranchApiService } from '../../branch/services/branch-api-service';
import { BranchModule } from 'src/modules/branch/module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    ListingModule,
    ProductModule,
    OrganisationModule,
    TicketModule,
    BranchModule,
  ],
  declarations: [NewPagesDashlet, ListingDashboard],
  providers: [
    ListingCarouselImageApiService,
    ListingOrganisationService,
    BranchApiService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [NewPagesDashlet, ListingDashboard],
})
export class ListingAdminModule {}
